import {
  CreateRechargeRequest,
  CreateRechargeResponse,
  Recharge,
  RechargeFlow,
  RechargeKind,
  RechargeResponse,
  RechargeSummary,
} from "@app/types";
import HttpService from "@core/services/http/http.service";

class _RechargeService {
  /** status: lọc theo trạng thái (is_succeeded của API: 0 chờ thanh toán, 1 thành công, 2 đã huỷ, 3 hết hạn) */
  public getRecharges(
    page: number,
    filter: { flow?: RechargeFlow; kind?: RechargeKind; keyword?: string; status?: number } = {}
  ) {
    return HttpService.get<RechargeResponse>("/recharges", {
      queryParams: { page, flow: filter.flow, kind: filter.kind, keyword: filter.keyword, is_succeeded: filter.status },
    });
  }

  /** Nạp trong tháng, tổng đã nạp, tổng đã chi, số lệnh đang chờ */
  public getSummary() {
    return HttpService.get<RechargeSummary>("/recharges/summary");
  }

  public createRecharge(createRechargeRequest: CreateRechargeRequest) {
    return HttpService.post<CreateRechargeResponse>("/recharges/request", {
      body: { ...createRechargeRequest },
    });
  }

  public cancelRecharge(rechargeId: string) {
    return HttpService.patch<Recharge>(`/recharges/${rechargeId}`);
  }
}

const RechargeService = new _RechargeService();

export default RechargeService;
